module.exports = __webpack_public_path__ + "img/icon-instagram.2f2497e6.svg";